import { useCallback } from "react";
import { EodSettingsApi, useAPIAction } from "melco-shared-logic";

export const useDeleteEodSettingss = () => {
    const [deleteEodSettings] = useAPIAction(
        EodSettingsApi,
        async (api) => {
            const data = await api.eodDeleteSettings();

            return {
                successMessages: [{ message: "default" }],
                data,
            };
        },
        {
            translationPrefix: "eodsettings.actions.delete",
        }
    );

    return useCallback(
        async () => {
            // const successfullyDeleted: string[] = [];


            try {
                await deleteEodSettings();
                //  successfullyDeleted.push();
            } catch (e) {
                // error handling is already done in useAPIAction
            }


            // return successfullyDeleted;
        },
        [deleteEodSettings]
    );
};
